import { Link } from 'react-router-dom';
import { Anchor } from '@mantine/core';
import BestPriceLabel, { type BestPriceAction, type BestPriceTone } from './BestPriceLabel';

interface BestPriceLinkProps {
  /** Ссылка на страницу действия (встречное предложение «Купить»/«Продать»). */
  readonly to: string;
  /** Лучшая встречная цена, ₽/т (sell — FCA, buy — CPT). */
  readonly price: number;
  /** Что делает пользователь: 'sell' → «Продать по X», 'buy' → «Купить по X». */
  readonly action: BestPriceAction;
  /** Визуальный тир (см. BestPriceLabel). */
  readonly tone?: BestPriceTone;
  /** Выгода относительно моей цены, ₽/т (со знаком) — только где есть привязка. */
  readonly advantage?: number;
}

// Единый CTA «лучшая цена» (ссылка) для всех разделов: BestPriceLabel внутри Anchor → страница
// встречного предложения с действием. Поднят над растянутой ссылкой-оверлеем карточки (zIndex 2 +
// stopPropagation) — в обычном потоке (грид/деталь) безвредно. Вид и доступное имя — в BestPriceLabel.
// Без своего aria-label: имя ссылки берётся из текста (действие + цена + оценка выгоды), иначе aria-label
// перекрыл бы оценку выгоды и скрыл бы её от скринридера. Чисто презентационный: решение «показывать ли
// действие» (напр. скрыть для агента) — у вызывающего.
export default function BestPriceLink({ to, price, action, tone, advantage }: BestPriceLinkProps) {
  return (
    <Anchor
      component={Link}
      to={to}
      // Ховер рисует сам чип BestPriceLabel (по цвету фона) — underline у ссылки отключаем.
      // inline-flex: ссылка облегает чип, кликабельна вся его область (включая отступы).
      underline="never"
      style={{ position: 'relative', zIndex: 2, display: 'inline-flex' }}
      onClick={(event) => event.stopPropagation()}
    >
      <BestPriceLabel price={price} action={action} tone={tone} advantage={advantage} />
    </Anchor>
  );
}
